import React, { Fragment } from 'react';
import { Form, Row, Col, Container, Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { ThemeProvider, Button, SvgIcon, createTheme } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { object, string, array } from '../../Helpers/Validators/customValidators';
import { MultiSelectInput, SelectInput, StyledRadioInput } from "../../Helpers/Inputs/index";
import InputTheme from './Helpers/InputTheme';
import FamilyIcon from '../../../icons/FamilyMembers.svg?react';
import getFamilyMembers from "../../Helpers/Lists/FamilyMembers";
import getAgeClasses from "../../Helpers/Lists/AgeClasses";

import "./FamilyHistory.scss";
import { yupResolver } from '@hookform/resolvers/yup';

export default function FamilyHistory(props) {

  const formMethods = useForm({
    resolver: yupResolver(FamilyHistory.ValidationSchema),
    mode: 'all',
    reValidateMode: 'all',
    defaultValues: props.formState
  });

  const { handleSubmit, trigger } = formMethods;

  const handleValueChange = (field, value) => {
    props.onFieldChange(field, value);
    trigger(field);
  };

  const onSubmit = () => {
    props.onNext();
  };

  return (
    <ThemeProvider theme={(theme) => createTheme({
      ...theme,
      ...InputTheme(),
    })}>
      <Container className="personalize-step">
        <FormProvider {...formMethods}>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="justify-content-center family-history">
              <Col lg={4} md={8} sm={12}>
                <Row className="justify-content-center pt-2">
                  <div className={`icon-container background-color-16`}>
                    <SvgIcon component={FamilyIcon} color="primary" fontSize="large" />
                  </div>
                </Row>
                <Row className="justify-content-center mainTitle">
                  <h4>Family Medical History</h4>
                </Row>
                {/* Cancer */}
                <div className='mb-3'>
                  <p className="formElementTitle">I have had a parent or sibling who was diagnosed with cancer prior to age 70.</p>
                  <StyledRadioInput
                    name="diagnosedWithCancer"
                    id="diagnosedWithCancer"
                    value={props.formState.diagnosedWithCancer}
                    options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                    onChange={e => handleValueChange('diagnosedWithCancer', e)}
                    isWhiteBackground={true}
                    isBlankIcon={true}
                  />
                </div>

                {props.formState.diagnosedWithCancer === "Yes" &&
                  <Fragment>
                    <div className='mb-3'>
                      <MultiSelectInput
                        name="familyMembersDiagnosedWithCancer"
                        id="familyMembersDiagnosedWithCancer"
                        value={props.formState.familyMembersDiagnosedWithCancer ? props.formState.familyMembersDiagnosedWithCancer : []}
                        onChange={(e) => handleValueChange('familyMembersDiagnosedWithCancer', e.target.value)}
                        label="Family Member(s) Diagnosed"
                        selectOptions={getFamilyMembers()}
                      />
                    </div>

                    {(props.formState.familyMembersDiagnosedWithCancer && props.formState.familyMembersDiagnosedWithCancer.includes("Father")) &&
                      <Card className="pb-0 pt-3 px-3 mb-3">
                        <p className="formElementTitle">My father Passed away from cancer</p>
                        <div className='mb-3'>
                          <StyledRadioInput
                            name="fatherPassedAwayByCancer"
                            id="fatherPassedAwayByCancer"
                            value={props.formState.fatherPassedAwayByCancer}
                            options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                            onChange={e => handleValueChange('fatherPassedAwayByCancer', e)}
                            isBlankIcon={true}
                          />
                        </div>

                        {props.formState.fatherPassedAwayByCancer === "Yes" &&
                          <div className='mb-3'>
                            <SelectInput
                              name="fatherAgeOfDeathByCancer"
                              id="fatherAgeOfDeathByCancer"
                              label="Father's Age of Death"
                              value={props.formState.fatherAgeOfDeathByCancer}
                              onChange={e => handleValueChange('fatherAgeOfDeathByCancer', e.target.value)}
                              selectOptions={getAgeClasses()}
                            />
                          </div>
                        }

                        {props.formState.fatherPassedAwayByCancer === "No" &&
                          <div className='mb-3'>
                            <SelectInput
                              name="fatherAgeOfDiagnosisForCancer"
                              id="fatherAgeOfDiagnosisForCancer"
                              label="Father's Age of Diagnosis"
                              value={props.formState.fatherAgeOfDiagnosisForCancer}
                              onChange={e => handleValueChange('fatherAgeOfDiagnosisForCancer', e.target.value)}
                              selectOptions={getAgeClasses()}
                            />
                          </div>
                        }
                      </Card>
                    }

                    {(props.formState.familyMembersDiagnosedWithCancer && props.formState.familyMembersDiagnosedWithCancer.includes("Mother")) &&
                      <Card className="pb-0 pt-3 px-3  mb-3">
                        <p className="formElementTitle"> My mother Passed away from cancer</p>
                        <div className='mb-3'>
                          <StyledRadioInput
                            name="motherPassedAwayByCancer"
                            id="motherPassedAwayByCancer"
                            value={props.formState.motherPassedAwayByCancer}
                            options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                            onChange={e => handleValueChange('motherPassedAwayByCancer', e)}
                            isBlankIcon={true}
                          />
                        </div>
                        {props.formState.motherPassedAwayByCancer === "Yes" &&
                          <div className='mb-3'>
                            <SelectInput
                              name="motherAgeOfDeathByCancer"
                              id="motherAgeOfDeathByCancer"
                              label="Mother's Age of Death"
                              value={props.formState.motherAgeOfDeathByCancer}
                              onChange={e => handleValueChange('motherAgeOfDeathByCancer', e.target.value)}
                              selectOptions={getAgeClasses()}
                            />
                          </div>
                        }

                        {props.formState.motherPassedAwayByCancer === "No" &&
                          <div className='mb-3'>
                            <SelectInput
                              name="motherAgeOfDiagnosisForCancer"
                              id="motherAgeOfDiagnosisForCancer"
                              label="Mother's Age of Diagnosis"
                              value={props.formState.motherAgeOfDiagnosisForCancer}
                              onChange={e => handleValueChange('motherAgeOfDiagnosisForCancer', e.target.value)}
                              selectOptions={getAgeClasses()}
                            />
                          </div>
                        }
                      </Card>
                    }

                    {(props.formState.familyMembersDiagnosedWithCancer && props.formState.familyMembersDiagnosedWithCancer.includes("Sibling")) &&
                      <Card className="pb-0 pt-3 px-3  mb-3">
                        <p className="formElementTitle">My sibling Passed away from cancer</p>
                        <div className='mb-3'>
                          <StyledRadioInput
                            name="siblingPassedAwayByCancer"
                            id="siblingPassedAwayByCancer"
                            value={props.formState.siblingPassedAwayByCancer}
                            options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                            onChange={e => handleValueChange('siblingPassedAwayByCancer', e)}
                            isBlankIcon={true}
                          />
                        </div>

                        {props.formState.siblingPassedAwayByCancer === "Yes" &&
                          <div className='mb-3'>
                            <SelectInput
                              name="siblingAgeOfDeathByCancer"
                              id="siblingAgeOfDeathByCancer"
                              label="Sibling's Age of Death"
                              value={props.formState.siblingAgeOfDeathByCancer}
                              onChange={e => handleValueChange('siblingAgeOfDeathByCancer', e.target.value)}
                              selectOptions={getAgeClasses()}
                            />
                          </div>
                        }

                        {props.formState.siblingPassedAwayByCancer === "No" &&
                          <div className='mb-3'>
                            <SelectInput
                              name="siblingAgeOfDiagnosisForCancer"
                              id="siblingAgeOfDiagnosisForCancer"
                              aria-label="siblingAgeOfDiagnosisForCancer"
                              label="Sibling's Age of Diagnosis"
                              value={props.formState.siblingAgeOfDiagnosisForCancer}
                              onChange={e => handleValueChange('siblingAgeOfDiagnosisForCancer', e.target.value)}
                              selectOptions={getAgeClasses()}
                            />
                          </div>
                        }
                      </Card>
                    }
                  </Fragment>
                }

                {/* Cardiovascular */}
                <div className='mb-3'>
                  <p className="formElementTitle">I have had a parent or sibling diagnosed with cardiovascular/heart disease prior to age 70.</p>
                  <StyledRadioInput
                    name="diagnosedWithCardiovascular"
                    id="diagnosedWithCardiovascular"
                    value={props.formState.diagnosedWithCardiovascular}
                    options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                    onChange={e => handleValueChange('diagnosedWithCardiovascular', e)}
                    isWhiteBackground={true}
                    isBlankIcon={true}
                  />
                </div>

                {props.formState.diagnosedWithCardiovascular === "Yes" &&
                  <Fragment>
                    <div className='mb-3'>
                      <MultiSelectInput
                        name="familyMembersDiagnosedWithCardiovascular"
                        id="familyMembersDiagnosedWithCardiovascular"
                        value={props.formState.familyMembersDiagnosedWithCardiovascular ? props.formState.familyMembersDiagnosedWithCardiovascular : []}
                        onChange={(e) => handleValueChange('familyMembersDiagnosedWithCardiovascular', e.target.value)}
                        label="Family Member(s) Diagnosed"
                        selectOptions={getFamilyMembers()}
                      />
                    </div>

                    {(props.formState.familyMembersDiagnosedWithCardiovascular && props.formState.familyMembersDiagnosedWithCardiovascular.includes("Father")) &&
                      <Card className="pb-0 pt-3 px-3 mb-3">
                        <p className="formElementTitle">My father Passed away from cardiovascular/heart disease</p>
                        <div className='mb-3'>
                          <StyledRadioInput
                            name="fatherPassedAwayByCardiovascular"
                            id="fatherPassedAwayByCardiovascular"
                            value={props.formState.fatherPassedAwayByCardiovascular}
                            options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                            onChange={e => handleValueChange('fatherPassedAwayByCardiovascular', e)}
                            isBlankIcon={true}
                          />
                        </div>

                        {props.formState.fatherPassedAwayByCardiovascular === "Yes" &&
                          <div className='mb-3'>
                            <SelectInput
                              name="fatherAgeOfDeathByCardiovascular"
                              id="fatherAgeOfDeathByCardiovascular"
                              aria-label="fatherAgeOfDeathByCardiovascular"
                              label="Father's Age of Death"
                              value={props.formState.fatherAgeOfDeathByCardiovascular}
                              onChange={e => handleValueChange('fatherAgeOfDeathByCardiovascular', e.target.value)}
                              selectOptions={getAgeClasses()}
                            />
                          </div>
                        }

                        {props.formState.fatherPassedAwayByCardiovascular === "No" &&
                          <div className='mb-3'>
                            <SelectInput
                              name="fatherAgeOfDiagnosisForCardiovascular"
                              id="fatherAgeOfDiagnosisForCardiovascular"
                              aria-label="fatherAgeOfDiagnosisForCardiovascular"
                              label="Father's Age of Diagnosis"
                              value={props.formState.fatherAgeOfDiagnosisForCardiovascular}
                              onChange={e => handleValueChange('fatherAgeOfDiagnosisForCardiovascular', e.target.value)}
                              selectOptions={getAgeClasses()}
                            />
                          </div>
                        }
                      </Card>
                    }

                    {(props.formState.familyMembersDiagnosedWithCardiovascular && props.formState.familyMembersDiagnosedWithCardiovascular.includes("Mother")) &&
                      <Card className="pb-0 pt-3 px-3  mb-3">
                        <p className="formElementTitle">My mother Passed away from cardiovascular/heart disease</p>
                        <div className='mb-3'>
                          <StyledRadioInput
                            name="motherPassedAwayByCardiovascular"
                            id="motherPassedAwayByCardiovascular"
                            value={props.formState.motherPassedAwayByCardiovascular}
                            options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                            onChange={e => handleValueChange('motherPassedAwayByCardiovascular', e)}
                            isBlankIcon={true}
                          />
                        </div>

                        {props.formState.motherPassedAwayByCardiovascular === "Yes" &&
                          <div className='mb-3'>
                            <SelectInput
                              name="motherAgeOfDeathByCardiovascular"
                              id="motherAgeOfDeathByCardiovascular"
                              aria-label="motherAgeOfDeathByCardiovascular"
                              label="Mother's Age of Death"
                              value={props.formState.motherAgeOfDeathByCardiovascular}
                              onChange={e => handleValueChange('motherAgeOfDeathByCardiovascular', e.target.value)}
                              selectOptions={getAgeClasses()}
                            />
                          </div>
                        }

                        {props.formState.motherPassedAwayByCardiovascular === "No" &&
                          <div className='mb-3'>
                            <SelectInput
                              name="motherAgeOfDiagnosisForCardiovascular"
                              id="motherAgeOfDiagnosisForCardiovascular"
                              aria-label="motherAgeOfDiagnosisForCardiovascular"
                              label="Mother's Age of Diagnosis"
                              value={props.formState.motherAgeOfDiagnosisForCardiovascular}
                              onChange={e => handleValueChange('motherAgeOfDiagnosisForCardiovascular', e.target.value)}
                              selectOptions={getAgeClasses()}
                            />
                          </div>
                        }
                      </Card>
                    }

                    {(props.formState.familyMembersDiagnosedWithCardiovascular && props.formState.familyMembersDiagnosedWithCardiovascular.includes("Sibling")) &&
                      <Card className="pb-0 pt-3 px-3 mb-3">
                        <p className="formElementTitle">My sibling Passed away from cardiovascular/heart disease</p>
                        <div className='mb-3'>
                          <StyledRadioInput
                            name="siblingPassedAwayByCardiovascular"
                            id="siblingPassedAwayByCardiovascular"
                            value={props.formState.siblingPassedAwayByCardiovascular}
                            options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                            onChange={e => handleValueChange('siblingPassedAwayByCardiovascular', e)}
                            isBlankIcon={true}
                          />
                        </div>

                        {props.formState.siblingPassedAwayByCardiovascular === "Yes" &&
                          <div className='mb-3'>
                            <SelectInput
                              name="siblingAgeOfDeathByCardiovascular"
                              id="siblingAgeOfDeathByCardiovascular"
                              aria-label="siblingAgeOfDeathByCardiovascular"
                              label="Sibling's Age of Death"
                              value={props.formState.siblingAgeOfDeathByCardiovascular}
                              onChange={e => handleValueChange('siblingAgeOfDeathByCardiovascular', e.target.value)}
                              selectOptions={getAgeClasses()}
                            />
                          </div>
                        }

                        {props.formState.siblingPassedAwayByCardiovascular === "No" &&
                          <div className='mb-3'>
                            <SelectInput
                              name="siblingAgeOfDiagnosisForCardiovascular"
                              id="siblingAgeOfDiagnosisForCardiovascular"
                              aria-label="siblingAgeOfDiagnosisForCardiovascular"
                              label="Sibling's Age of Diagnosis"
                              value={props.formState.siblingAgeOfDiagnosisForCardiovascular}
                              onChange={e => handleValueChange('siblingAgeOfDiagnosisForCardiovascular', e.target.value)}
                              selectOptions={getAgeClasses()}
                            />
                          </div>
                        }
                      </Card>
                    }
                  </Fragment>
                }
              </Col>
            </Row>

            <Row className="pre-quote-nav-control">
              <Col className="text-start btn-back">
                <Button variant="outlined" size="medium" color="primary" className="px-4" onClick={props.onBack}>
                  BACK
                </Button>
              </Col>
              <Col className="text-end">
                <Button variant="contained" size="medium" color="primary" type="submit" className="px-4">
                  NEXT
                </Button>
              </Col>
            </Row>
          </Form>
        </FormProvider>
      </Container>
    </ThemeProvider>
  );
}

FamilyHistory.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};


FamilyHistory.ValidationSchema = object().shape({
  diagnosedWithCancer: string().required('Diagnosed With Cancer is required.'),
  familyMembersDiagnosedWithCancer: array()
    .of(string())
    .transform((value) => (Array.isArray(value) ? value : [])) // Convert "" to []
    .when("diagnosedWithCancer", {
      is: "Yes",
      then: (schema) => schema.min(1, 'Family Member Diagnosed For Cancer is required.').required('Family Member Diagnosed For Cancer is required.'),
      otherwise: (schema) => schema.notRequired()
    }),

  fatherPassedAwayByCancer: string().when(
    ['diagnosedWithCancer', 'familyMembersDiagnosedWithCancer'],
    ([diagnosedWithCancer, familyMembersDiagnosedWithCancer], schema) => {
      if (diagnosedWithCancer === "Yes" && familyMembersDiagnosedWithCancer.includes('Father')) {
        return schema.required('Father Passed By Cancer is required.');
      }
      return schema.notRequired();
    }
  ),
  fatherAgeOfDeathByCancer: string().when(
    ['diagnosedWithCancer', 'familyMembersDiagnosedWithCancer', 'fatherPassedAwayByCancer'],
    ([diagnosedWithCancer, familyMembersDiagnosedWithCancer, fatherPassedAwayByCancer], schema) => {
      if (diagnosedWithCancer === "Yes" && familyMembersDiagnosedWithCancer.includes('Father') && fatherPassedAwayByCancer === 'Yes') {
        return schema.required('Age is required.');
      }
      return schema.notRequired();
    }
  ),
  fatherAgeOfDiagnosisForCancer: string().when(
    ['diagnosedWithCancer', 'familyMembersDiagnosedWithCancer', 'fatherPassedAwayByCancer'],
    ([diagnosedWithCancer, familyMembersDiagnosedWithCancer, fatherPassedAwayByCancer], schema) => {
      if (diagnosedWithCancer === "Yes" && familyMembersDiagnosedWithCancer.includes('Father') && fatherPassedAwayByCancer === 'No') {
        return schema.required('Age is required.');
      }
      return schema.notRequired();
    }
  ),
  motherPassedAwayByCancer: string().when(
    ['diagnosedWithCancer', 'familyMembersDiagnosedWithCancer'],
    ([diagnosedWithCancer, familyMembersDiagnosedWithCancer], schema) => {
      if (diagnosedWithCancer === "Yes" && familyMembersDiagnosedWithCancer.includes('Mother')) {
        return schema.required('Mother Passed By Cancer is required.');
      }
      return schema.notRequired();
    }
  ),
  motherAgeOfDeathByCancer: string().when(
    ['diagnosedWithCancer', 'familyMembersDiagnosedWithCancer', 'motherPassedAwayByCancer'],
    ([diagnosedWithCancer, familyMembersDiagnosedWithCancer, motherPassedAwayByCancer], schema) => {
      if (diagnosedWithCancer === "Yes" && familyMembersDiagnosedWithCancer.includes('Mother') && motherPassedAwayByCancer === 'Yes') {
        return schema.required('Age is required.');
      }
      return schema.notRequired();
    }
  ),
  motherAgeOfDiagnosisForCancer: string().when(
    ['diagnosedWithCancer', 'familyMembersDiagnosedWithCancer', 'motherPassedAwayByCancer'],
    ([diagnosedWithCancer, familyMembersDiagnosedWithCancer, motherPassedAwayByCancer], schema) => {
      if (diagnosedWithCancer === "Yes" && familyMembersDiagnosedWithCancer.includes('Mother') && motherPassedAwayByCancer === 'No') {
        return schema.required('Age is required.');
      }
      return schema.notRequired();
    }
  ),
  siblingPassedAwayByCancer: string().when(
    ['diagnosedWithCancer', 'familyMembersDiagnosedWithCancer'],
    ([diagnosedWithCancer, familyMembersDiagnosedWithCancer], schema) => {
      if (diagnosedWithCancer === "Yes" && familyMembersDiagnosedWithCancer.includes('Sibling')) {
        return schema.required('Sibling Passed By Cancer is required.');
      }
      return schema.notRequired();
    }
  ),
  siblingAgeOfDeathByCancer: string().when(
    ['diagnosedWithCancer', 'familyMembersDiagnosedWithCancer', 'siblingPassedAwayByCancer'],
    ([diagnosedWithCancer, familyMembersDiagnosedWithCancer, siblingPassedAwayByCancer], schema) => {
      if (diagnosedWithCancer === "Yes" && familyMembersDiagnosedWithCancer.includes('Sibling') && siblingPassedAwayByCancer === 'Yes') {
        return schema.required('Age is required.');
      }
      return schema.notRequired();
    }
  ),
  siblingAgeOfDiagnosisForCancer: string().when(
    ['diagnosedWithCancer', 'familyMembersDiagnosedWithCancer', 'siblingPassedAwayByCancer'],
    ([diagnosedWithCancer, familyMembersDiagnosedWithCancer, siblingPassedAwayByCancer], schema) => {
      if (diagnosedWithCancer === "Yes" && familyMembersDiagnosedWithCancer.includes('Sibling') && siblingPassedAwayByCancer === 'No') {
        return schema.required('Age is required.');
      }
      return schema.notRequired();
    }
  ),

  diagnosedWithCardiovascular: string().required('Diagnosed With Cardiovascular is required.'),
  familyMembersDiagnosedWithCardiovascular: array().of(string())
    .transform((value) => (Array.isArray(value) ? value : [])) // Convert "" to []
    .when("diagnosedWithCardiovascular", {
      is: "Yes",
      then: (schema) => schema.min(1, 'Family Member Diagnosed For Cardiovascular is required.').required('Family Member Diagnosed For Cardiovascular is required.'),
      otherwise: (schema) => schema.notRequired()
    }),

  fatherPassedAwayByCardiovascular: string().when(
    ['diagnosedWithCardiovascular', 'familyMembersDiagnosedWithCardiovascular'],
    ([diagnosedWithCardiovascular, familyMembersDiagnosedWithCardiovascular], schema) => {
      if (diagnosedWithCardiovascular === "Yes" && familyMembersDiagnosedWithCardiovascular.includes('Father')) {
        return schema.required('Father Passed By Cardiovascular is required.');
      }
      return schema.notRequired();
    }
  ),
  fatherAgeOfDeathByCardiovascular: string().when(
    ['diagnosedWithCardiovascular', 'familyMembersDiagnosedWithCardiovascular', 'fatherPassedAwayByCardiovascular'],
    ([diagnosedWithCardiovascular, familyMembersDiagnosedWithCardiovascular, fatherPassedAwayByCardiovascular], schema) => {
      if (diagnosedWithCardiovascular === "Yes" && familyMembersDiagnosedWithCardiovascular.includes('Father') && fatherPassedAwayByCardiovascular === 'Yes') {
        return schema.required('Age is required.');
      }
      return schema.notRequired();
    }
  ),
  fatherAgeOfDiagnosisForCardiovascular: string().when(
    ['diagnosedWithCardiovascular', 'familyMembersDiagnosedWithCardiovascular', 'fatherPassedAwayByCardiovascular'],
    ([diagnosedWithCardiovascular, familyMembersDiagnosedWithCardiovascular, fatherPassedAwayByCardiovascular], schema) => {
      if (diagnosedWithCardiovascular === "Yes" && familyMembersDiagnosedWithCardiovascular.includes('Father') && fatherPassedAwayByCardiovascular === 'No') {
        return schema.required('Age is required.');
      }
      return schema.notRequired();
    }
  ),

  motherPassedAwayByCardiovascular: string().when(
    ['diagnosedWithCardiovascular', 'familyMembersDiagnosedWithCardiovascular'],
    ([diagnosedWithCardiovascular, familyMembersDiagnosedWithCardiovascular], schema) => {
      if (diagnosedWithCardiovascular === "Yes" && familyMembersDiagnosedWithCardiovascular.includes('Mother')) {
        return schema.required('Mother Passed By Cardiovascular is required.');
      }
      return schema.notRequired();
    }
  ),
  motherAgeOfDeathByCardiovascular: string().when(
    ['diagnosedWithCardiovascular', 'familyMembersDiagnosedWithCardiovascular', 'motherPassedAwayByCardiovascular'],
    ([diagnosedWithCardiovascular, familyMembersDiagnosedWithCardiovascular, motherPassedAwayByCardiovascular], schema) => {
      if (diagnosedWithCardiovascular === "Yes" && familyMembersDiagnosedWithCardiovascular.includes('Mother') && motherPassedAwayByCardiovascular === 'Yes') {
        return schema.required('Age is required.');
      }
      return schema.notRequired();
    }
  ),
  motherAgeOfDiagnosisForCardiovascular: string().when(
    ['diagnosedWithCardiovascular', 'familyMembersDiagnosedWithCardiovascular', 'motherPassedAwayByCardiovascular'],
    ([diagnosedWithCardiovascular, familyMembersDiagnosedWithCardiovascular, motherPassedAwayByCardiovascular], schema) => {
      if (diagnosedWithCardiovascular === "Yes" && familyMembersDiagnosedWithCardiovascular.includes('Mother') && motherPassedAwayByCardiovascular === 'No') {
        return schema.required('Age is required.');
      }
      return schema.notRequired();
    }
  ),
  siblingPassedAwayByCardiovascular: string().when(
    ['diagnosedWithCardiovascular', 'familyMembersDiagnosedWithCardiovascular'],
    ([diagnosedWithCardiovascular, familyMembersDiagnosedWithCardiovascular], schema) => {
      if (diagnosedWithCardiovascular === "Yes" && familyMembersDiagnosedWithCardiovascular.includes('Sibling')) {
        return schema.required('Sibling Passed By Cardiovascular is required.');
      }
      return schema.notRequired();
    }
  ),
  siblingAgeOfDeathByCardiovascular: string().when(
    ['diagnosedWithCardiovascular', 'familyMembersDiagnosedWithCardiovascular', 'siblingPassedAwayByCardiovascular'],
    ([diagnosedWithCardiovascular, familyMembersDiagnosedWithCardiovascular, siblingPassedAwayByCardiovascular], schema) => {
      if (diagnosedWithCardiovascular === "Yes" && familyMembersDiagnosedWithCardiovascular.includes('Sibling') && siblingPassedAwayByCardiovascular === 'Yes') {
        return schema.required('Age is required.');
      }
      return schema.notRequired();
    }
  ),
  siblingAgeOfDiagnosisForCardiovascular: string().when(
    ['diagnosedWithCardiovascular', 'familyMembersDiagnosedWithCardiovascular', 'siblingPassedAwayByCardiovascular'],
    ([diagnosedWithCardiovascular, familyMembersDiagnosedWithCardiovascular, siblingPassedAwayByCardiovascular], schema) => {
      if (diagnosedWithCardiovascular === "Yes" && familyMembersDiagnosedWithCardiovascular.includes('Sibling') && siblingPassedAwayByCardiovascular === 'No') {
        return schema.required('Age is required.');
      }
      return schema.notRequired();
    }
  ),
})


FamilyHistory.DefaultFormState = (prefill = false) => {
  return {
    diagnosedWithCancer: '',
    familyMembersDiagnosedWithCancer: '',
    fatherPassedAwayByCancer: '',
    fatherAgeOfDeathByCancer: '',
    fatherAgeOfDiagnosisForCancer: '',
    motherPassedAwayByCancer: '',
    motherAgeOfDeathByCancer: '',
    motherAgeOfDiagnosisForCancer: '',
    siblingPassedAwayByCancer: '',
    siblingAgeOfDeathByCancer: '',
    siblingAgeOfDiagnosisForCancer: '',

    diagnosedWithCardiovascular: '',
    familyMembersDiagnosedWithCardiovascular: '',
    fatherPassedAwayByCardiovascular: '',
    fatherAgeOfDeathByCardiovascular: '',
    fatherAgeOfDiagnosisForCardiovascular: '',
    motherPassedAwayByCardiovascular: '',
    motherAgeOfDeathByCardiovascular: '',
    motherAgeOfDiagnosisForCardiovascular: '',
    siblingPassedAwayByCardiovascular: '',
    siblingAgeOfDeathByCardiovascular: '',
    siblingAgeOfDiagnosisForCardiovascular: '',
  };
};
